import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";
import { ShiftBottomSheetBookabilityCriteriaCard } from "@src/appV2/redesign/Shift/BottomSheet/BookabilityCriteriaCard";
import { type ShiftBoost } from "@src/appV2/redesign/Shift/ShiftBoost/api/schema";
import { formatDistanceToNowStrict, parseISO } from "date-fns";

export function BaseShiftBoostCard(props: { shiftBoosts: ShiftBoost[] }) {
  const { shiftBoosts } = props;
  // Already sorted by expiration date
  // eslint-disable-next-line prefer-destructuring
  const soonestExpiringShiftBoost = shiftBoosts[0];
  const { amount, expiresAt } = soonestExpiringShiftBoost.attributes;
  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      intent="success"
      title={`${formatDollarsAsUsd(amount, { maximumFractionDigits: 0 })} Shift Boost applied (${
        shiftBoosts.length
      } left)`}
      description={`Book in the next ${formatDistanceToNowStrict(
        parseISO(expiresAt)
      )} to earn extra on this shift`}
      illustrationType="shift-boost"
    />
  );
}
